import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35563ab0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增权限菜单")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("菜单"))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("权限"))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("权限菜单"))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("不支持的类型"))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("已禁用"))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("已启用")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "权限菜单管理",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.addOrUpdateMenu
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.list && _ctx.list.length)
      ? (_openBlock(), _createBlock(_component_a_table, {
          key: 0,
          dataSource: _ctx.list,
          columns: _ctx.columns,
          loading: _ctx.loading,
          childrenColumnName: "sub",
          bordered: "",
          "default-expand-all-rows": false,
          rowKey: "id",
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'type' && text)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (Number(text) === 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "pink"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }))
                    : (Number(text) === 2)
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 1,
                          color: "blue"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }))
                      : (Number(text) === 3)
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 2,
                            color: "green"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_a_tag, {
                            key: 3,
                            color: "gray"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }))
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'disable')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  text
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "red"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "green"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }))
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.changeMenuStatus(record)),
                    style: _normalizeStyle([{"margin":"5px"}, record.disable ? '':'color: darkblue'])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(record.disable ? "启用" : "禁用"), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "style"]),
                  _createVNode(_component_a_button, {
                    size: "small",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.addOrUpdateMenu(record)),
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否删除菜单?",
                    okButtonProps: {danger: true},
                    onConfirm: ($event: any) => (_ctx.deleteMenus(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        danger: "",
                        size: "small",
                        type: "primary",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"]))
      : _createCommentVNode("", true)
  ], 64))
}